import { motion } from "framer-motion";
import { COLORS } from "../constants/colors";
import { useState } from "react";
import ERPModal from "./ERPModal";

const CTASection = () => {
 const [showModal, setShowModal] = useState(false);
  return (
    <section
      className="py-20 px-8 md:px-20 rounded-3xl"
      style={{ backgroundColor: COLORS.primary, color: COLORS.background }}
    >
      <div className="flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="text-center md:text-left md:flex-1 space-y-6">
          <h2 className="text-4xl font-bold">
            Ready to Transform Your School?
          </h2>
          <p className="text-lg max-w-xl">
            Get started with our cloud-based ERP and simplify school management
            like never before.
          </p>
          <motion.button
            whileHover={{ scale: 1.05 }}
            style={{
              backgroundColor: COLORS.secondary,
              color: COLORS.textPrimary,
            }}
            className="px-8 py-4 rounded-full font-semibold"
            onClick={()=>{setShowModal(true)}}
          >
            Schedule a Demo →
          </motion.button>
        </div>

        <div className="md:flex-1 flex justify-center">
          <img
            src='/assets/phone-gurukul.png'
            alt="School ERP Illustration"
            className="w-full max-w-md rounded-xl shadow-lg"
          />
        </div>
      </div>
      <ERPModal isOpen={showModal} onClose={() => setShowModal(false)} />
        </section>
  );
};

export default CTASection;
